import enUS from 'antd/locale/en_US';
import zhTW from 'antd/locale/zh_TW';

export const EN_US = enUS;
export const ZH_TW = zhTW;
